// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#app h4[data-v-7c9e41db]{font-weight:700;font-size:1em;margin-bottom:1.5em}#app ul[data-v-7c9e41db]{list-style:none;padding:0;margin:0;font-size:1em;text-align:center}#app ul li[data-v-7c9e41db]{display:inline-block;margin:1.5em;width:8em;vertical-align:top;cursor:pointer}#app ul li span[data-v-7c9e41db]{font-size:1em}#app ul li.match[data-v-7c9e41db]{font-weight:700;background-color:inherit}#app ul li.match img[data-v-7c9e41db]{border:.2rem solid #b48c50}", ""]);
// Exports
module.exports = exports;
